import React from 'react'
import { useSecuritiesReportChunkDetailPageDatafetch } from './datafetch'
import { SecuritiesReportChunkDetailPagePresentation } from './presentation'

export const SecuritiesReportChunkDetailPage: React.FC = () => {
  const props = useSecuritiesReportChunkDetailPageDatafetch()
  return <SecuritiesReportChunkDetailPagePresentation {...props} />
}
